$bog_blitz_blog_menu $mol_page
	title \Блог
	items *
	page? \
	body /
		<= Logo $mol_image
			uri \bog/blitz/assets/logo.svg
		<= Heading $mol_paragraph
			title \Blitz Quiz
		<= Subtitle $mol_paragraph
			title \Реалтайм квизы для митапов и мероприятий
		<= Nav $mol_list
			rows <= nav_rows /
	Link* $mol_link
		arg *
			screen <= link_slug* \
		title <= link_title* \
